var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'dh-psy-data-viz': true,'dh-psy-data-viz--no-margin': _vm.noMargin, 'dh-psy-data-viz--small': _vm.small }},[_c('div',{class:{
    'dh-psy-data-viz__wrapper': true,
    'dh-psy-data-viz__wrapper--left': _vm.align === 'left',
    'dh-psy-data-viz__wrapper--right': _vm.align === 'right'
  }},[_c('ImportedIllustration',{attrs:{"id":_vm.id}})],1),_vm._v(" "),(_vm.description)?_c('DataVizDescription',{attrs:{"align":_vm.align,"description":_vm.description}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }